import { useEffect, useState } from 'react'

/** Telefon = dar ekran + dokunmatik işaretçi. Tarayıcıda "masaüstü sitesi" istenince görünüm alanı ~980 px olur → eşleşmez. */
export const PHONE_VIEWPORT_QUERY = '(max-width: 480px) and (pointer: coarse)'

function readMatch(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia(PHONE_VIEWPORT_QUERY).matches
}

/** Görünüm telefon mu (döndürme / yeniden boyutta güncellenir). SSR ya da matchMedia yoksa `false`. */
export function usePhoneViewport(): boolean {
  const [isPhone, setIsPhone] = useState<boolean>(readMatch)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mql = window.matchMedia(PHONE_VIEWPORT_QUERY)
    const onChange = () => setIsPhone(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return isPhone
}
